<template>
  <span v-if="wordList && wordList.length">
    <span 
      v-for="(value,index) in wordList"
      :key="index">
      <Ellipsis
        v-if="value.length > length && index === 0"
        :text="value"
        :length="length"/>
      <span v-else-if="index < showWordCount">
        <span v-if="index !== 0">|</span>
        {{value}}
      </span>
    </span>
    <Tooltip v-if="showPopover" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
      <div slot="content">
        <span 
          v-for="(value,index) in wordList"
          :key="index">
          <span v-if="index >= showWordCount">
            {{value}}<br>
          </span>
        </span>
      </div>
      <span class="pointer d-inline" v-if="remainingWordCount">
        <span class="text-rounded">+ {{remainingWordCount}}</span>
      </span>
    </Tooltip>
  </span>
  <span v-else> - </span>
</template>
<script>
import Ellipsis from './Ellipsis';
export default {
  props: ['wordList','length'],
  components: {
    Ellipsis,
  },
  data() {
    return {
      showPopover: false,
      hoverContent: '',
    }
  },
  computed: {
    showWordCount() {
      let result = 1;
      const firstWordLength = this.wordList[0] ? this.wordList[0].length : 0;
      let remainingLength = this.length - firstWordLength;
      this.wordList.forEach((element,index) => {
        if(element && index > 0) {
          remainingLength = remainingLength - (element.length+1);
          if (remainingLength >= 0) {
            result += 1;
          } else {
            this.showPopover = true;
          }
        }
      });
      return result;
    },
    wordListCount() {
      return this.wordList && this.wordList.length;
    },
    remainingWordCount() {
      return this.wordListCount - this.showWordCount;
    },
  },
};
</script>
